import i18n from '@/common/js/i18n'

// 活动规则集合
const ruleSet = [
  '', // 为与活动规则序号统一，这里index=0为空字符串，不代表任何意义
  i18n.gettext('活动时间' /* R1 */),
  i18n.gettext('邀请好友成为%s新用户，好友领取您送出的红包，并在活动时间截止前完成订单且无退款，无论是否使用领取的红包下单，您均可获得%s[优惠券]奖励' /* R2 */),
  i18n.gettext('奖励会在邀请成功后的48小时内发放入您的账号，您可在%s-钱包-券中查看' /* R3 */),
  i18n.gettext('您邀请的好友必须是%s新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户' /* R4 */),
  i18n.gettext('您邀请的好友需通过%s下单，通过其他渠道下单不发放邀请奖励' /* R5 */),
  i18n.gettext('优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用' /* R6 */),
  i18n.gettext('本优惠活动仅限[%s]开通%s区域' /* R7 */),
  i18n.gettext('本优惠活动仅限%s[在线支付]的订单享受，不可提现转赠' /* R8 */),
  i18n.gettext('单笔订单金额满足优惠券使用门槛金额时方可使用，单笔订单只能使用一张优惠券，使用优惠后，如订单金额超出部分需用户自行支付' /* R9 */),
  i18n.gettext('一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任' /* R10 */),
  i18n.gettext('收餐人手机号与领取券时输入的手机号和账号注册手机号必须为同一号码' /* R11 */),
  i18n.gettext('关于本活动的任何问题，请联系%s客服' /* R12 */),
  'FoodC_page_Rewards_are_dWeY' /* R13 */,
  'FoodC_page_Invite_friends_oGuj' /* R14 只有日语和英语 对应R2的UIkey */,
  'FoodC_page_Rewards_will_NhMd' /* R15 只有日语和英语 对应R3的UIkey */,
  'FoodC_page_Your_invited_sPpR' /* R16 只有日语和英语 对应R4的UIkey */,
  'FoodC_page_The_threshold_yZFq' /* R17 只有日语和英语 对应R6的UIkey */,
  'FoodC_page_This_special_fYuo' /* R18 只有日语和英语 对应R7的UIkey */,
  'FoodC_page_Upon_discovery_baTq' /* R19 只有日语和英语 对应R10的UIkey */,
  'FoodC_page_For_any_IWNZ', /* R20 只有日语和英语 对应R12的UIkey */
  'FoodC_rule_14_Up_dovx' /* R21 每个用户每天最多用券2张 */
]

export default ruleSet
